import { z, ZodType } from 'zod';

export type Bet = {
	time: string;
	bet: number;
	profit: number;
	multiplier: number;
};

export const betSchema: ZodType<Bet> = z.object({
	time: z.string(),
	bet: z.number(),
	profit: z.number(),
	multiplier: z.number(),
});
